import { Text as DesignSystemText } from "@octopusdeploy/design-system-components";
import DebounceValue from "~/components/DebounceValue/DebounceValue";
import UseLabelStrategy from "~/components/LabelStrategy/LabelStrategy";
const Text = UseLabelStrategy(DesignSystemText, (fieldName) => fieldName);
export const DebounceText = DebounceValue(Text);
export default Text;
